let TrezorConnect;
export async function loadTrezorConnect() {
    if (!TrezorConnect) {
        const module = await import('@bangjelkoski/trezor-connect-web');
        TrezorConnect = (module.TrezorConnect ||
            module.default.TrezorConnect);
    }
    return TrezorConnect;
}
